import React, { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { errorToast } from "../../shared/Toast";
import { ChevronDown } from "react-feather";

const Tabset = () => {
	const [loading, setLoading] = useState(false);
	const [inputs, setInputs] = useState({
		code: "",
		couponType: "",
		startDate: "",
		endDate: "",
		startTime: "",
		endTime: "",
		discountType: "",
		amount: "",
		maximumUses: "",
		maxAmountPerOrder: "",
	});

	const clickActive = (event) => {
		document.querySelector(".nav-link").classList.remove("show");
		event.target.classList.add("show");
	};

	const handleInputChange = (e, key) => {
		setInputs((prev) => ({ ...prev, [key]: e.target.value }));
	};

	const handleDiscard = () => {
		setInputs({});
	};

	const handleValidSubmit = async (e) => {
		e.preventDefault();

		// const timeValidation = validateTimes()
		// if (!timeValidation.isValid) {
		//   errorToast(timeValidation.message)
		//   return
		// }

		try {
			setLoading(true);

			//   const formData = new FormData();
			//   formData.append("merchantID", branchData.merchantID);
			//   formData.append("name", branchData.name);
			//   formData.append("address", branchData.address);
			//   formData.append("lat", `${branchData.lat}`);
			//   formData.append("lng", `${branchData.lng}`);
			//   formData.append("openingTime", branchData.openingTime);
			//   formData.append("closingTime", branchData.closingTime);
			//   formData.append("dataType", "branch");
			//   if (imageForPayload) formData.append("image1", imageForPayload);

			//   const response = await addBranch(formData);

			//   if (response) {
			//     successToast("Branch added successfully");
			//     navigate("/branches/branchesList");
			//   }
			//   errorToast(response?.data?.message ?? "Error adding branch");
		} catch (error) {
			console.error("Error adding branch:", error);
			errorToast("Failed to add branch");
		} finally {
			setLoading(false);
		}
	};

	return (
		<Row className="product-adding">
			<Col xl="4">
			</Col>
			<Col xl="8">
				<Form className="needs-validation add-product-form" onSubmit={handleValidSubmit}>

					<div className="form form-label-center">

						<FormGroup className="form-group mb-3 row">
							<Label className="col-xl-3 col-sm-4 mb-0">
								Code :
							</Label>
							<div className="col-xl-8 col-sm-7">
								<Input
									className="form-control"
									type="text"
									value={inputs.code}
									onChange={(e) => handleInputChange(e, "code")}
									required
								/>
							</div>
						</FormGroup>

						<FormGroup className="form-group mb-3 row">
							<Label className="col-xl-3 col-sm-4 mb-0">
								Coupon Type :
							</Label>
							<div className="col-xl-8 col-sm-7 position-relative">
								<select
									className="form-control"
									value={inputs.couponType}
									onChange={(e) => handleInputChange(e, "couponType")}
								>
									<option value="">Select Coupon Type</option>
									<option value="on_order">On Order</option>
									<option value="on_product">On Product</option>
								</select>
								<span
									style={{
										position: "absolute",
										top: "50%",
										right: "26px",
										transform: "translateY(-50%)",
										pointerEvents: "none",
									}}
								>
									<ChevronDown />
								</span>
							</div>
						</FormGroup>

						<FormGroup className="form-group mb-3 row">
							<Label className="col-xl-3 col-sm-4 mb-0">
								Discount Type :
							</Label>
							<div className="col-xl-8 col-sm-7 position-relative">
								<select
									className="form-control"
									value={inputs.discountType}
									onChange={(e) => handleInputChange(e, "discountType")}
									required
								>
									<option value="">Select Discount Type</option>
									<option value="by_amount">By Amount</option>
									<option value="by_percentage">By Percentage</option>
								</select>
								<span
									style={{
										position: "absolute",
										top: "50%",
										right: "26px",
										transform: "translateY(-50%)",
										pointerEvents: "none",
									}}
								>
									<ChevronDown />
								</span>
							</div>
						</FormGroup>

						<FormGroup className="form-group mb-3 row">
							<Label className="col-xl-3 col-sm-4 mb-0">
								Start Date :
							</Label>
							<div className="col-xl-8 col-sm-7">
								<Input
									type="time"
									className="form-control"
									selected={inputs.startDate}
									onChange={(date) => setInputs(prev => ({ ...prev, startDate: date }))}
								/>
							</div>
						</FormGroup>

						<FormGroup className="form-group mb-3 row">
							<Label className="col-xl-3 col-sm-4 mb-0">
								End Date :
							</Label>
							<div className="col-xl-8 col-sm-7">
								<Input
									disabled={!inputs.startDate}
									type="time"
									className="form-control"
									selected={inputs.endDate}
									onChange={(date) => setInputs(prev => ({ ...prev, endDate: date }))}
								/>
							</div>
						</FormGroup>

						<FormGroup className="form-group mb-3 row">
							<Label className="col-xl-3 col-sm-4 mb-0">
								Start Time :
							</Label>
							<div className="col-xl-8 col-sm-7">
								<Input
									className="form-control"
									type="time"
									value={inputs.startTime}
									onChange={(e) => handleInputChange(e, "startTime")}
								/>
							</div>
						</FormGroup>

						<FormGroup className="form-group mb-3 row">
							<Label className="col-xl-3 col-sm-4 mb-0">
								End Time :
							</Label>
							<div className="col-xl-8 col-sm-7">
								<Input
									disabled={!inputs.startTime}
									className="form-control"
									type="time"
									value={inputs.endTime}
									onChange={(e) => handleInputChange(e, "endTime")}
								/>
							</div>
						</FormGroup>

						<FormGroup className="form-group mb-3 row">
							<Label className="col-xl-3 col-sm-4 mb-0">
								Amount :
							</Label>
							<div className="col-xl-8 col-sm-7">
								<Input
									className="form-control"
									type="number"
									value={inputs.amount}
									onChange={(e) => handleInputChange(e, "amount")}
									required
									min="0"
								/>
							</div>
						</FormGroup>

						<FormGroup className="form-group mb-3 row">
							<Label className="col-xl-3 col-sm-4 mb-0">
								Maximum Uses :
							</Label>
							<div className="col-xl-8 col-sm-7">
								<Input
									className="form-control"
									type="number"
									value={inputs.maximumUses}
									onChange={(e) => handleInputChange(e, "maximumUses")}
									min="0"
								/>
							</div>
						</FormGroup>

						<FormGroup className="form-group mb-3 row">
							<Label className="col-xl-3 col-sm-4 mb-0">
								Max Amount Per Order :
							</Label>
							<div className="col-xl-8 col-sm-7">
								<Input
									className="form-control"
									type="number"
									value={inputs.maxAmountPerOrder}
									onChange={(e) => handleInputChange(e, "maxAmountPerOrder")}
									min="0"
								/>
							</div>
						</FormGroup>

					</div>

				</Form>
				<div className="offset-xl-3 offset-sm-4 mt-3">
					<Button color="primary" type="submit" style={{ marginRight: "10px" }} onClick={handleValidSubmit}>
						Submit
					</Button>
					<Button color="secondary" onClick={handleDiscard}>
						Cancel
					</Button>
				</div>
			</Col>

		</Row>
	);
};

export default Tabset;
